module.exports = __webpack_public_path__ + "img/alert.4cdd630c.svg";